<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header">Nueva Serie para Abono</h5>
                <div class="form-desc">Adición de una nueva serie para abono</div>
                <div class="row">
                  <div class="col-sm-3 col-md-2">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.serie && current.errors.serie.length > 0 }"
                      >serie</label>
                      <input
                        v-model="current.serie"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="Serie"
                        type="text"
                        v-bind:class="{ 'is-invalid': current.errors.serie && current.errors.serie.length > 0 }"
                      >
                      <small
                        v-if="current.errors && current.errors.serie"
                        class="form-text text-danger"
                      >{{ current.errors.serie[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-2">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.nombre && current.errors.nombre.length > 0 }"
                      >Nombre</label>
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{ 'is-invalid': current.errors.nombre && current.errors.nombre.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-2">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.ultimo_impreso && current.errors.ultimo_impreso.length > 0 }"
                      >Ultimo Impreso</label>
                      <input
                        v-model="current.ultimo_impreso"
                        class="form-control"
                        placeholder="Ultimo Impreso"
                        v-bind:class="{ 'is-invalid': current.errors.ultimo_impreso && current.errors.ultimo_impreso.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.ultimo_impreso"
                        class="form-text text-danger"
                      >{{ current.errors.ultimo_impreso[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-3">
                      <div class="form-group">
                        <label
                          v-bind:class="{ 'text-danger': current.errors.tienda && current.errors.tienda.length > 0 }"
                        >Tienda</label>
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.tienda"
                          @change="refreshTienda"
                          @input="$emit('input', $event.target.value)"
                        >
                          <option
                            v-for="(c, key) in tiendas"
                            :value="c.codigo"
                            :key="key"
                          >{{ c.nombre }}</option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.tienda"
                          class="form-text text-danger"
                        >{{ current.errors.tienda[0] }}</small>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                      <div class="form-group">
                        <label
                          v-bind:class="{ 'text-danger': current.errors.tienda && current.errors.tienda.length > 0 }"
                        >Tipo Abono</label>
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.cxc_tipo_abono"
                          @change="refreshAbono"
                          @input="$emit('input', $event.target.value)"
                        >
                          <option
                            v-for="(c, key) in abonos"
                            :value="c.id"
                            :key="key"
                          >{{ c.id }}</option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.tienda"
                          class="form-text text-danger"
                        >{{ current.errors.tienda[0] }}</small>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              checked
                              class="form-check-input"
                              name="optionsRadios"
                              v-model="current.estado"
                              type="radio"
                              value="true"
                            >Activo
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              class="form-check-input"
                              v-model="current.estado"
                              name="optionsRadios"
                              type="radio"
                              value="false"
                            >Inactivo
                          </label>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link class="btn btn-default" :to="{ name: 'cxc-abono-serie', params: {  }}">
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import AbonoSerieService from "@/services/cxc/AbonoSerieService";
import Notifications from "@/notifications/notifications";


export default {
  data() {
    return {
      current: {
        errors: {}
      }
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      abonos: "abonos/tipoabono"
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      AbonoSerieService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.errors = [];
        this.current.id;
        this.refreshTienda();
    });
}
  this.refreshTienda();
  this.refreshAbono();
},
  methods: {
    refreshTienda() {
      let self = this;
      self.$store.dispatch("catalogos/tiendas", {
        activa: true,
        tienda: self.current.tienda,
        quitar_paginacion: true
      });
    },
    refreshAbono() {
      let self = this;
      self.$store.dispatch("abonos/tipoabono", {
        activa: true,
        abono: self.current.cxc_tipo_abono,
        quitar_paginacion: true
      });
    },
guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
        delete current.id;
      }
      AbonoSerieService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.id;
          self.current.errors = {};
          Notifications.alert.success(
            "Serie Abono",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cxc-abono-serie",
            params: { id: self.current.id }
          });
        })
        .catch(error => {
          Vue.nextTick(function() {
            self.current.errors = Object.assign({}, error.response.data);
            console.log(self.current.errors);
          });
        });
    },
    showModal(e) {
      e.preventDefault();
    }
  }
};
</script>
